import { Table } from "@frends/ui-components/react";

export default Table;
